function bytesToHex(buffer) {
    return [...new Uint8Array(buffer)].map((b) => b.toString(16).padStart(2, '0')).join('');
}
/** Works in browsers and Node 20+ (global Web Crypto). */
export class WebCryptoSha256Hasher {
    async sha256Hex(data) {
        const digest = await crypto.subtle.digest('SHA-256', data);
        return bytesToHex(digest);
    }
}
//# sourceMappingURL=web-crypto-hasher.js.map